<template>
<!--头部-->
  <div class=" navHead" style="padding-right: 10px;">
    <div class="nav">
      <div class="navLeft">
        <ul class="navItem">
          <li @click="logoDetail()"><img class="logoIcon" src="../../assets/logo.png" /></li>
<!--          <li><router-link to="/"  exact>首页</router-link></li>-->
<li>
          <el-menu  :default-active="activeIndex"  mode="horizontal" @select="handleSelect" >
            <el-menu-item>  <li><router-link to="/"  exact>首页</router-link></li></el-menu-item>
            <el-submenu index="2">
              <template slot="title">  <li :class="{active: $route.meta.mainMenu === 'about'}">
                <router-link to="/about"  exact>关于我们</router-link></li></template>
              <el-menu-item index="2-1"><router-link to="/about" class="menu-link" :class="{ 'active': $route.path === '/about' }" exact>
                  勤博教育介绍</router-link>
              </el-menu-item>
<!--              <el-menu-item index="2-2"><router-link to="/about1" class="menu-link" :class="{ 'active': $route.path === '/about1' }" exact>-->
<!--                  核心创始人</router-link>-->
<!--              </el-menu-item>-->
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">  <li :class="{active: $route.meta.mainMenu === 'college'}">
                <router-link to="/college"  exact>国开物业学院</router-link></li></template>
              <el-menu-item index="2-1"><router-link to="/college" class="menu-link" :class="{ 'active': $route.path === '/college' }" exact>
                  学院介绍
                </router-link>
              </el-menu-item>
              <el-menu-item index="2-2"><router-link to="/college3" class="menu-link" :class="{ 'active': $route.path === '/college3' }" exact>
                  专业介绍
                </router-link>
              </el-menu-item>
              <el-menu-item index="2-3"><router-link to="/college4" class="menu-link" :class="{ 'active': $route.path === '/college4' }" exact>
              师资团队</router-link>
              </el-menu-item>
              <el-menu-item index="2-4"><router-link to="/college5" class="menu-link" :class="{ 'active': $route.path === '/college5' }" exact>
              学分银行
            </router-link>
              </el-menu-item>
              <el-menu-item index="2-5"><router-link to="/college2" class="menu-link" :class="{ 'active': $route.path === '/college2' }" exact>
              招生简章</router-link></el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">  <li :class="{active: $route.meta.mainMenu === 'skill'}">
                <router-link to="/jnrd2"  exact>职业技能培训体系</router-link></li></template>
              <el-menu-item index="2-1"><router-link to="/jnrd2" class="menu-link" :class="{ 'active': $route.path === '/jnrd2' }" exact>
                物业管理师职业技能等级认定培训
              </router-link>
              </el-menu-item>
              <el-menu-item index="2-2"><router-link to="/jnrd5" class="menu-link" :class="{ 'active': $route.path === '/jnrd5' }" exact>
                物业管理项目经理培训
              </router-link>
              </el-menu-item>
<!--              <el-menu-item index="2-2"><router-link to="/jnrd2" class="menu-link" :class="{ 'active': $route.path === '/jnrd2' }" exact>-->
<!--                项目介绍-->
<!--              </router-link>-->
<!--              </el-menu-item>-->
<!--              <el-menu-item index="2-3"><router-link to="/jnrd3" class="menu-link" :class="{ 'active': $route.path === '/jnrd3' }" exact>-->
<!--                报考流程</router-link>-->
<!--              </el-menu-item>-->
<!--              <el-menu-item index="2-4"><router-link to="/jnrd4" class="menu-link" :class="{ 'active': $route.path === '/jnrd4' }" exact>-->
<!--                证书查询-->
<!--              </router-link>-->
<!--              </el-menu-item>-->
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">  <li :class="{active: $route.meta.mainMenu === 'ceping'}">
                <router-link to="/ceping"  exact>测培一体化体系</router-link></li></template>
              <el-menu-item index="2-1"><router-link to="/srlcp" class="menu-link" :class="{ 'active': $route.path === '/srlcp' }" exact>
                物业岗位胜任力测培一体化系统
              </router-link>
              </el-menu-item>
              <el-menu-item index="2-2"><router-link to="/srlcp2" class="menu-link" :class="{ 'active': $route.path === '/srlcp2' }" exact>
                企业定制内训
              </router-link>
              </el-menu-item>
            </el-submenu>
            <el-menu-item>  <li><router-link to="/zypx"  exact>五博系列课程</router-link></li></el-menu-item>
            <el-menu-item>  <li><router-link to="/linkus"  exact>联系我们</router-link></li></el-menu-item>
          </el-menu>
</li>

<!--          <li :class="{active: $route.meta.mainMenu === 'skill'}"><router-link to="/skill"  exact>职业技能认定培训</router-link></li>-->

<!--          <li :class="{active: $route.meta.mainMenu === 'ceping'}"><router-link to="/ceping"  exact>测培一体化体系</router-link></li>-->
<!--&lt;!&ndash;          <li><router-link to="/occupation"  exact>职业培训</router-link></li>&ndash;&gt;-->
<!--          <li :class="{active: $route.meta.mainMenu === 'occupation'}"><router-link to="/occupation"  exact>五博系列课程</router-link></li>-->
<!--          <li><router-link to="/news"  exact>勤博动态</router-link></li>-->
<!--          <li><a @click.prevent.stop="courseAll">在线课程</a>-->
<!--            <div class="class_content">-->
<!--              <ul>-->
<!--                <li v-for="first in typeList">-->
<!--                  <a class="title" @click.stop.prevent="courseList(first.id,1)">{{first.courseTypeName}}</a>-->
<!--                  <a v-for="(second,index) in first.child" :key="index" @click.stop.prevent="courseList(second.id,2)">{{second.courseTypeName}}</a>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </li>-->

<!--          <li><router-link to="/kaoshi" exact :class="showOrder == 'kaoshi' ? 'navActive router-link-active' : ''">认证考试</router-link></li>-->
<!--          <li><router-link to="/vip"  exact>VIP会员</router-link></li>-->
          <!--<li><a  @click.stop.prevent="goZhuanhuan">学分认定</a></li>-->
<!--          <li><router-link to="/linkus"  exact>联系我们</router-link></li>-->
          <!--<li><router-link to="/help" exact >帮助中心</router-link></li>-->
        </ul>
      </div>
<!--      <div class=" navRight">-->
<!--&lt;!&ndash;        &lt;!&ndash;未登录&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="userDeal" v-show="!isShow">&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="downThis" >客户端下载&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="downapp" >&ndash;&gt;-->
<!--&lt;!&ndash;              <p>扫码下载勤博教育APP</p>&ndash;&gt;-->
<!--&lt;!&ndash;              <img src="../../assets/app.png" alt="" width="134">&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <span @click="loginform"  class="loginBtn">登录</span>&ndash;&gt;-->

<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        &lt;!&ndash;已登录&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="userDeal" v-show="isShow">&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="username">&ndash;&gt;-->
<!--&lt;!&ndash;            <img class="userImage" src="../../assets/headdefault.png" v-if="avatar === '' || avatar === null || avatar === undefined"/>&ndash;&gt;-->
<!--&lt;!&ndash;            <img class="userImage" :src="avatar" width="32" v-else/>&ndash;&gt;-->
<!--&lt;!&ndash;            <p v-if="nickName === '' || nickName === null || nickName === undefined">您好！未设置</p>&ndash;&gt;-->
<!--&lt;!&ndash;            <p v-else>您好！{{nickName}}</p>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <router-link to="/ziliao" class="userCenter" >个人中心</router-link>&ndash;&gt;-->
<!--&lt;!&ndash;          <span class="signOut" @click="logOut">退出</span>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        &lt;!&ndash;<div class="searchOut":style="{width:isShow? '39%':'55%'}">&ndash;&gt;&ndash;&gt;-->
<!--        <div class="searchOut" style="width: initial;">-->
<!--          <Input prefix="ios-search" placeholder="搜索课程" v-model="keyWord" :maxlength="40" class="inputSearch" @keydown.enter.native="search"/>-->
<!--          <span class="searchBtn" @click="search" >搜索</span>-->
<!--        </div>-->
<!--      </div>-->


            </div>
          <loginmodal  ref="loginA"></loginmodal>
          </div>

        </template>
        <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  /* 确保 active 样式有足够优先级 */
  .navItem li.active {
    background-color: #957960 !important;
  }

  .navItem li.active a {
    color: #fff !important;
    background-color: #957960 !important;
  }

  /* 使用深度选择器确保穿透 */
  /deep/ .navItem li.active a {
    color: #fff !important;
    background-color: #957960 !important;
  }

  /* 或者使用全局样式 */
  :global(.navItem li.active a) {
    color: #fff !important;
    background-color: #957960 !important;
  }


  /* 方法1：隐藏箭头图标 */
  /deep/ .el-submenu__title .el-icon-arrow-down:before {
    content: '' !important;
  }

   /deep/ .el-submenu__title .el-icon-arrow-up:before {
    content: '' !important;
  }
  /* 穿透Element UI的样式，去掉二级菜单的底部边框 */
  /deep/ .el-menu--horizontal .el-submenu .el-menu-item {
    border-bottom: none !important;
  }

  /* 若hover/active时出现，也覆盖掉 */
  /deep/ .el-menu--horizontal .el-submenu .el-menu-item:hover,
  /deep/ .el-menu--horizontal .el-submenu .el-menu-item.is-active {
    border-bottom: none !important;
  }


  /deep/ .menu-link .el-menu--horizontal .el-submenu .el-menu-item {
    border-bottom: none !important;
  }

  /* 若hover/active时出现，也覆盖掉 */
  /deep/ .menu-link .el-menu--horizontal .el-submenu .el-menu-item:hover,
  /deep/ .menu-link .el-menu--horizontal .el-submenu .el-menu-item.is-active {
    border-bottom: none !important;
  }

  /deep/ .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
    border-bottom: none !important;
  }
.menu-link{
  color:#999;
    border-bottom: none !important;
}
  .menu-link:hover {
    color: #957960 !important; /* 金色 */
    font-weight:bold;
  }

  .el-submenu {
    white-space: nowrap;
  padding: 0px;
}
  /deep/  .el-submenu__title{
    padding: 0px 2px;
  }

  .el-menu.el-menu--horizontal{
    border-bottom: 0;
  }
  .el-menu-item{
    padding: 0px 8px;
  }

  .menu-item {
    position: relative;
    display: inline-block;

  }
  .arrow {
    font-size: 12px;
    color: #999;
    margin-left: 5px;
    transition: transform 0.01s;
  }

  &:hover .arrow {
    color: #957960;
  }
  .navHead{
    background-color: #fff;
    padding:0 10px ;
    min-width: 1200px;
    position: fixed;
    z-index: 999;
    width: 100%;
    .nav{
    .navLeft{
      width:80%;
      float: left;
      padding:3px 10px 0px;
      @media screen and (max-width: 1600px) {
        .logoIcon{
          margin: 10px 2px 0 0;

        }
      }
      @media screen and (max-width: 1600px) and (min-width: 1200px){
        .logoIcon{
          margin: 10px 0px 0 0;
        }
      }
      @media screen and (max-width: 1800px) and (min-width: 1600px){
        .logoIcon{
          margin: 10px 0px 0 0;
        }
      }
      .navItem{
        li{
          display: inline-flex;
          vertical-align: middle;
          height: 60px;
          line-height: 60px;
          float: left;
          margin:0;
          align-items: center; /* 垂直居中 */
          justify-content: center; /* 水平居中 */
          .logoIcon{
            margin: auto 20px;
            display: inline-block;
            //width: 250px;
            width: 100px
          }
          a{
            display: inline-block;
            font-size: 16px;
            color: #666;
            text-align: center;
            padding: 0 5px;
            border-bottom: 0;
            &:hover{
              background-color: #957960;
              color: #fff;
              border-bottom: 0;
            }
          }
          .navActive{
            background-color: #957960;
            color: #fff;
          }
          .class_content{
            display: none;
            width: 1000px;
            background-color: #fff;
            box-shadow:0 2px 6px  rgba(102,102,102,0.36);
            position: absolute;
            z-index: 90;
            min-height: 426px;
            max-height: 426px;
            overflow: auto;
            left: 0px;
            top: 59px;
            padding: 0px;
            text-align: left;
            li{
              border-bottom: 1px solid #f0f0f0;
              text-align: left;
              height: 60px;
              line-height: 60px;
              width: 100%;
              .title{
                font-size: 14px;
                color: #000;
              }
              a{
                font-size: 12px;
                color: #666;
                position: relative;
                border-right: 1px solid #dbdbdb;
                padding:0 10px;
                line-height: 13px;
                &:hover{
                  background-color: transparent;
                  font-weight: 700;
                  color: #957960;
                }
              }
              a:last-child{
                border-right: none;
              }
              &:last-child{
                border-bottom: none;
              }
            }
          }
        }
        li:nth-child(8):hover .class_content{
          display: block;
          transition: all 0.3s;
        }
      }
    }
    .navRight{
      float: right;
      padding-top: 15px;
      .searchOut{
        float: right;
        margin-right: 8px;
        width: 42%;
        height: 32px;
        display: table;
        overflow: hidden;
        border: 1px solid #957960;
        border-radius: 3px;
        .ivu-input{
          display: table-cell;
          border: 1px solid #957960;
          width: 100%;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          color: #333;
          padding: 0 15px 0 5px;
        }

        .searchBtn{
          display: table-cell;
          width: 1px;
          height: 30px;
          text-align: center;
          font-size: 14px;
          color: #fff;
          line-height: 30px;
          white-space: nowrap;
          padding: 0 15px;
          background-color: #957960;
          cursor: pointer;
          &:active{
            background-color: darken(#957960,3%);
          }
        }
      }
      .userDeal{
        float: right;
        text-align: right;
        position: relative;
        .downapp{
          display: none;
          background-color: #fff;
          text-align: center;
          font-size: 13px;
          color: #333;
          padding:  5px 10px 0;
          position: absolute;
          top:60px;
          right: -30px;
          box-shadow:0 2px 6px  rgba(102,102,102,0.36);
          z-index: 9;
          p{
            margin-bottom: 5px;
          }
        }
        .downThis,.loginBtn{
          display: inline-block;
          vertical-align: middle;
          height: 32px;
          line-height: 32px;
          padding: 0 12px;
          position: relative;
          font-size: 14px;
          color: #666;
          cursor: pointer;
          &:hover{
            color: #957960;
          }
        }
        .downThis:hover .downapp{
          display: block;
        }
        .loginBtn{
          &::after{
            content: '';
            display: block;
            text-align: center;
            height: 12px;
            border-right: 1px solid #DBDBDB;
            position: absolute;;
            right: 0px;
            top: 10px;
          }
          &::after{
            left: 0px;
            right: inherit;
            border-left: 1px solid #DBDBDB;
            border-right: none;
          }
        }
        .username{
          display: inline-block;
          vertical-align: middle;
          //          .textEllipsis;
          position: relative;
          font-size: 14px;
          color: #333;
          height: 32px;
          line-height: 32px;
          padding: 0 10px 0 38px;
          p{
            max-width: 135px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .userImage{
            display: inline-block;
            width: 32px;
            height: 32px;
            position: absolute;
            left: 0px;
            top: 0px;
            overflow: hidden;
            border-radius: 50%;
          }
        }
        .userCenter,.signOut{
          display: inline-block;
          vertical-align: middle;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          margin: 0 10px;
          color: #957960;
          cursor: pointer;
        }
        .signOut{
          padding: 0 0 0 22px;
          background: url(../../assets/signout.png) no-repeat left center;
          background-size: 20px;
        }
      }
    }
    }
  }
  @media screen and (max-width: 1500px) {
    .navHead{
      padding: 0 80px;
      .navLeft .navItem li a{
        padding: 0 4px;
      }
    }
  }
  @media screen and (max-width: 1600px) and (min-width: 1500px){
    .navHead{
      .navLeft .navItem li a{
        padding: 0 10px;
      }
    }
  }
  @media only screen and (max-width: 1420px) and (min-width: 1200px){
    .navHead{
      padding: 0;
      .navLeft .navItem li a{
        padding: 0 7px;
      }
    }

  }
</style>
<script type="text/ecmascript-6">
  import loginmodal from './loginmodal'
  import {coursetypeList,centreInfoWeb} from '../../http'
  import {getStore,setStore} from '../../storage'

    export default {
        inject:['reload'],
        name: '',
        props: {},
        data() {
            return {
              isShow:false,
              typeList:'',
              keyWord:'',
              nickName:'',
              phone:'',
              avatar:'',
              showOrder: '',

            };
        },



        methods: {

          //跳转学分转换页面
          goZhuanhuan(){
            //用户是否登录，同时获取用户信息
            centreInfoWeb().then(res => {
                if(res.code === 200) {
                  this.$router.push({
                    name:'zhuanhuan3'
                  })
                }else{
                  this.$refs.loginA.showModal();
                }
            }).catch()
          },
          //显示登录框
          loginform(){
            this.$refs.loginA.showModal();
          },
          //用户登出
          logOut(){
            window.localStorage.clear();
            this.nickName = '';
            this.avatar = '';
            this.isShow = false;
            this.reload();
            this.$router.push({name:'index'});
          },
          //获取用户信息
          getInfo(){
            //判断用户是否登录
            if(getStore('token') !== null && getStore('token') !== undefined && getStore('token') !== '') {
              //获取用户信息
                centreInfoWeb().then(res => {
                  if(res.code === 200) {
                    this.nickName = res.data.nickName;
                    this.avatar = res.data.avatar;
                    this.isShow = true;
                  }else {
                    this.nickName = '';
                    this.avatar = '';
                    this.isShow = false;
                    this.getCourseType();
                    // this.reload();
                    /*if(this.$parent.getIndex !== undefined){
                      this.$parent.getIndex();
                      this.getCourseType()
                    }*/
                  }
                }).catch()
            }
          },
          //全部课程
          courseAll(){
            this.$router.push({
              name:'courselist',
              query:{
                coursetype:-1
              }
            })
            this.reload();
          },
          logoDetail(){
            this.$router.push({
              name:'college',
              query:{}
            })
          },
          //获取课程列表
          courseList(id,type){
            this.$router.push({
              name : 'courselist',
              query:  {
                coursetype:type,
                coursetypeId:id,
              }
             });
            this.reload();
          },
          //搜索课程
          search(){
            if(this.keyWord.trim() !== "") {
              this.reload();
              this.$router.push({
                name: 'search',
                query: {
                  keyWord: this.keyWord.trim(),
                }
              })
            }else{
              this.$Notice.warning({
                title: "课程搜索提醒",
                desc: "请输入搜索内容",
                duration: 3,
              });
            }
          },
          //课程列表初始化
          getCourseType(){
            coursetypeList().then(res => {
              this.typeList = res.data;
            }).catch();
          }
        },
        created() {
          //获取课程类型列表
          this.getCourseType();
          this.getInfo();
          let so = this.$parent.showOrder
          if(so != undefined && so != ''){
            this.showOrder = this.$parent.showOrder
          }
        },
        components: {
          loginmodal
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/template/header.vue